import { memo } from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { Radio } from "@base-ui/react/radio";
import { RadioGroup as RadioGroup$1 } from "@base-ui/react/radio-group";
//#region src/Radio/index.tsx
const gapClassName = {
	sm: "gap-2",
	md: "gap-4"
};
const RadioGroupInner = memo(({ renderRadioGroupElements, name, disabled, onClick, control, gap = "md", horizontal = false }) => {
	const radioElements = renderRadioGroupElements.map((element) => /* @__PURE__ */ jsxs("div", {
		className: cn("flex items-center", element.itemClassName),
		children: [
			element.icon && /* @__PURE__ */ jsx("span", {
				className: "mr-3",
				children: element.icon
			}),
			/* @__PURE__ */ jsx(Radio.Root, {
				id: element.id,
				value: element.value,
				disabled: disabled || element.disabled,
				className: cn("border-neutrals-80 bg-neutrals-95 focus:outline-system-info-50 relative size-[19px] shrink-0 rounded-full border-2", "data-[checked]:border-brand-40 data-[checked]:bg-brand-40", "data-[disabled]:bg-neutrals-80", "data-[checked]:data-[disabled]:!border-neutrals-70 data-[checked]:data-[disabled]:!bg-neutrals-70", element.radioClassName),
				children: /* @__PURE__ */ jsx(Radio.Indicator, {
					className: "flex h-full w-full items-center justify-center data-[unchecked]:hidden",
					children: /* @__PURE__ */ jsx("svg", {
						viewBox: "0 0 50 50",
						"aria-hidden": true,
						children: /* @__PURE__ */ jsx("circle", {
							fill: "white",
							r: "13",
							cx: "25",
							cy: "25"
						})
					})
				})
			}),
			/* @__PURE__ */ jsx("label", {
				htmlFor: element.id,
				className: cn("ml-3.5", element.labelClassName),
				children: element.label
			})
		]
	}, element.id));
	return /* @__PURE__ */ jsx(Controller, {
		control,
		name,
		render: ({ field }) => /* @__PURE__ */ jsx(RadioGroup$1, {
			className: cn("flex", horizontal ? "flex-row flex-wrap" : "flex-col", gapClassName[gap]),
			onValueChange: (value) => {
				onClick?.(value);
				field.onChange(value);
			},
			value: field.value,
			children: radioElements
		})
	});
});
RadioGroupInner.displayName = "RadioGroupInner";
/**
* RadioGroup из UI Kit (react-hook-form).
* @see https://www.figma.com/file/uRPlsieHFpRpRsYDX2KV1Q — Асубим РЖД UI Kit
*/
const RadioGroup = memo((props) => {
	const { control } = useFormContext();
	return /* @__PURE__ */ jsx(RadioGroupInner, {
		...props,
		control
	});
});
RadioGroup.displayName = "RadioGroup";
//#endregion
export { RadioGroup };

//# sourceMappingURL=index.js.map